import React, { Component } from "react";
import { connect } from "react-redux";

class Table extends Component {
    constructor(props) {
        super(props);
        this.changeRow = this.changeRow.bind(this);

        this.tbRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        /*
         * 削除時選択行移動
         * @since hara 2021-04-12
         */
        if (this.props.isDel) {
            const trs = this.tbRef.childNodes;
            const rowNum = trs.length;
            const selRow = parseInt(this.props.selRow);
            let newSelRow = null;

            if (selRow === rowNum) {
                //最終行削除の場合
                if (selRow !== 0) {
                    //複数行の場合前の行を選択
                    trs[rowNum - 1].click();
                    newSelRow = rowNum - 1;
                }
                this.props.dispatch(this.props.action(newSelRow));
            }
        }
    }

    /*
     * テーブル選択
     * @param {Event} e イベント情報
     * @since hara 2021-02-08
     */
    changeRow(e) {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });

        const tr = e.target.closest("tr");
        tr.classList.add("selRow");

        this.props.dispatch(this.props.action(parseInt(tr.id)));
    }

    render() {
        return (
            <div className={this.props.class} style={{ overflowY: "scroll" }}>
                <table className="table">
                    <thead>
                        <tr>
                            {this.props.tData.map((el, index) => (
                                <th className={el.class} key={index}>
                                    <p>{el.text}</p>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody ref={(ref) => (this.tbRef = ref)}>
                        {this.props.ds.map((el, index) => (
                            <tr id={index} key={index} onClick={this.changeRow}>
                                {this.props.tData.map((el2, index2) => (
                                    <td key={index2}>
                                        <p>{el2.ID === "ZAttr" ? (el[el2.ID] === "dep" ? "深度" : "標高") : el2.abbre === null ? el[el2.ID] : window.abbreText(el[el2.ID], el2.abbre)}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default connect()(Table);
